import { Injectable } from '@angular/core';
import { baseUrl } from 'src/app/global-variables';
import { UserDataService } from '../user-repository/user-data.service';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  PriceResponseModel,
  PlanCheckSubscriptionResponseModel,
} from 'src/app/core/model/api-response/shop-response-model';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import {
  PlanSubscriptionModel,
  SavedSubscriptionModel,
} from 'src/app/core/model/object/shop-model';
import { ShopDataService } from './shop-data.service';
import { DateHelper } from 'src/app/utils/date-helper';

@Injectable({
  providedIn: 'root',
})
export class ShopApiService {
  constructor(
    private userDataService: UserDataService,
    private shopDataService: ShopDataService,
    private http: HttpClient,
    private userRefreshTokenService: UserRefreshTokenService,
    private dateHelper: DateHelper
  ) {}

  public getPrices(discountCode?: string): Promise<GenericResponse> {
    let url = baseUrl + 'api/v3/plan';
    if (discountCode) {
      url += '?discountCode=' + discountCode;
    }
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<PriceResponseModel>(url, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        // console.log('plan prices ', res)

        if (res.success) {
          if (res.reward) {
            response = new GenericResponse(
              true,
              new GenericResponseData({ type: 'reward', reward: res.reward })
            );
          } else {
            response = new GenericResponse(
              true,
              new GenericResponseData({ type: 'plan', planPricesResponse: res })
            );
          }
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPrices();
            }
          });
        }
        if (e.error.message) {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: e.error.message })
          );
        } else {
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: 'خطای اتصال' })
          );
        }
        return response;
      });
  }

  async getPlanSubscription(force: boolean) {
    let response: GenericResponse;
    const subsResult = await this.shopDataService.getSubscription();
    if (!force && subsResult && subsResult.updatedAt) {
      if (
        this.dateHelper.isSameDay(new Date(subsResult.updatedAt), new Date())
      ) {
        response = new GenericResponse(true);
        return response;
      }
    }
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<PlanCheckSubscriptionResponseModel>(
        baseUrl + 'api/v2/subscription/check',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        // console.log('subscrption  ', res)
        if (res.success) {
          if (res.hasSub) {
            this.shopDataService.saveSubscription(
              new SavedSubscriptionModel(
                new Date().toISOString(),
                res.expireDate
              )
            );
          } else {
            this.shopDataService.saveSubscription(
              new SavedSubscriptionModel(new Date().toISOString(), 0)
            );
          }
          response = new GenericResponse(true);
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getPlanSubscription(force);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }
}
